import { inject } from '@angular/core';
import Keycloak from 'keycloak-js';

export interface UserProfile {
  id?: string;
  username?: string;
}

export abstract class AuthenticationService {
  abstract login: (redirectUri: string) => Promise<void>;
  abstract logout: () => Promise<void>;
  abstract isLoggedIn: () => boolean;
  abstract loadUserProfile: () => Promise<UserProfile>;
  abstract getUserName: () => Promise<string | undefined>;
  abstract getUserRoles: () => string[] | undefined;
  abstract getAccessToken: () => string | undefined;
}

export class KeycloakAuthenticationService extends AuthenticationService {
  private readonly keycloak = inject(Keycloak);

  override logout = () => this.keycloak.logout();
  override login = (redirectUri: string) => this.keycloak.login({ redirectUri });
  override isLoggedIn = () => !!this.keycloak.authenticated;
  override loadUserProfile = () => this.keycloak.loadUserProfile();
  override getUserName = () => this.keycloak.loadUserProfile().then((x) => x.username);
  override getUserRoles = () => {
    return this.keycloak.resourceAccess?.['backend'].roles;
  };
  override getAccessToken = () => this.keycloak.token;
}
